/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Document_CopyInputs */



/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Meeting_Document_CopyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_document_copy = /** @type {((inputs?: Meeting_Document_CopyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Document_CopyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kopiëren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier")
	return /** @type {LocalizedString} */ ("Copy")
});